import PaymentDataForm from 'components/PaymentData/PaymentDataForm/component';

export default PaymentDataForm;
